import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=c6a801bc&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6a801bc')) {
      api.createRecord('c6a801bc', component.options)
    } else {
      api.reload('c6a801bc', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=c6a801bc&", function () {
      api.rerender('c6a801bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WsokFfcD8Mlz/JS/comp/IncreaseNumber.vue"
export default component.exports